import axios from "axios";

import { sendError } from "../errors";
import store, { setShowSessionTooBigModal } from "../store";

export function request(urlOrOptions, params) {
  if (typeof urlOrOptions === "string") {
    urlOrOptions = { url: urlOrOptions, params };
  }

  return axios({
    ...urlOrOptions,
    headers: {
      ...(urlOrOptions.headers || {}),
      "X-CSRF-Token": document
        .querySelector("meta[name='csrf-token']")
        .getAttribute("content"),
    },
  })
    .then((response) => response.data)
    .catch((error) => {
      const data = error?.response?.data;
      sendError(error.message, data);
      handleError(
        { ...data, status: error?.response?.status } || {
          message: "Something unexpected happened.",
          status: 500,
        }
      );
    });
}

function handleError(error) {
  switch (error.action) {
    case "session_too_big":
      store.dispatch(setShowSessionTooBigModal(true));
      break;
    default:
      throw error;
  }
}
